define('home/views/common/ActivityCardView',[
    'backbone-marionette',
], function (
    Marionette
) {
    'use strict';

    var parent = Marionette.ItemView;
    var parentProto = parent.prototype;

    /**
     * @classdesc Abstract class for views that present activity data
     * @class
     */
    return parent.extend({
        constructor: function (options) {
            parentProto.constructor.call(this, options);

            // Toggle the unread class on this view's element based on boolean model attribute.
            //
            // Avoid using `className`, `initialize`, or `render` because these methods
            // increase the chance that a consuming developer will accidentally override
            // this feature (className because it can be passed as option to the constructor,
            // initialize and render because they are no-ops in Backbone and Marionette so
            // developers are used to implementing them without calling the parent method).
            //
            // Avoid using `setElement` because it is used by private method _ensureElement
            // (relying on it increases chance of breaking change when Backbone upgrades)
            this.listenTo(this.model, 'change:isFromUnreadQueue', this.updateUnreadClass);

            // Do not sync .unread class with model -- i.e., do not do:
            // this.updateUnreadClass();
            // because currently code in other places sets the initial state for .unread
        },

        /**
         * Toggle the unread class on this view's element based on boolean model attribute.
         */
        updateUnreadClass: function () {
            this.$el.toggleClass('unread', Boolean(this.model.get('isFromUnreadQueue')));
        },
    });
});

